/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MallEdit_mall$ref = any;
type MallShow_mall$ref = any;
export type UpdateMallInput = {|
  address?: ?string,
  clientMutationId?: ?string,
  email?: ?string,
  name?: ?string,
  pdfMapUrl?: ?string,
  phoneNumber?: ?string,
  mondayOpening?: ?number,
  mondayClosing?: ?number,
  tuesdayOpening?: ?number,
  tuesdayClosing?: ?number,
  wednesdayOpening?: ?number,
  wednesdayClosing?: ?number,
  thursdayOpening?: ?number,
  thursdayClosing?: ?number,
  fridayOpening?: ?number,
  fridayClosing?: ?number,
  saturdayOpening?: ?number,
  saturdayClosing?: ?number,
  sundayOpening?: ?number,
  sundayClosing?: ?number,
|};
export type updateMallMutationVariables = {|
  input: UpdateMallInput
|};
export type updateMallMutationResponse = {|
  +updateMall: ?{|
    +mall: ?{|
      +id: string,
      +$fragmentRefs: MallEdit_mall$ref & MallShow_mall$ref,
    |},
    +errors: ?$ReadOnlyArray<{|
      +key: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
  |}
|};
export type updateMallMutation = {|
  variables: updateMallMutationVariables,
  response: updateMallMutationResponse,
|};
*/


/*
mutation updateMallMutation(
  $input: UpdateMallInput!
) {
  updateMall(input: $input) {
    mall {
      id
      ...MallEdit_mall
      ...MallShow_mall
    }
    errors {
      key
      messages
    }
  }
}

fragment MallEdit_mall on Mall {
  name
  phoneNumber
  email
  pdfMapUrl
  address
  smallMapUrl
  largeMapUrl
  mondayOpening
  mondayClosing
  tuesdayOpening
  tuesdayClosing
  wednesdayOpening
  wednesdayClosing
  thursdayOpening
  thursdayClosing
  fridayOpening
  fridayClosing
  saturdayOpening
  saturdayClosing
  sundayOpening
  sundayClosing
}

fragment MallShow_mall on Mall {
  name
  phoneNumber
  email
  pdfMapUrl
  address
  shareableHomeUrl
  shareableFlashSaleOffersUrl
  smallMapUrl
  largeMapUrl
  homeUrl
  flashSaleOffersUrl
  mondayOpening
  mondayClosing
  tuesdayOpening
  tuesdayClosing
  wednesdayOpening
  wednesdayClosing
  thursdayOpening
  thursdayClosing
  fridayOpening
  fridayClosing
  saturdayOpening
  saturdayClosing
  sundayOpening
  sundayClosing
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMallInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messages",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateMallMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateMallPayload",
        "kind": "LinkedField",
        "name": "updateMall",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Mall",
            "kind": "LinkedField",
            "name": "mall",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MallEdit_mall"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MallShow_mall"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateMallMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateMallPayload",
        "kind": "LinkedField",
        "name": "updateMall",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Mall",
            "kind": "LinkedField",
            "name": "mall",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pdfMapUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "smallMapUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "largeMapUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mondayOpening",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mondayClosing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tuesdayOpening",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tuesdayClosing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wednesdayOpening",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wednesdayClosing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thursdayOpening",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thursdayClosing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fridayOpening",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fridayClosing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "saturdayOpening",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "saturdayClosing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sundayOpening",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sundayClosing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shareableHomeUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shareableFlashSaleOffersUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "homeUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flashSaleOffersUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateMallMutation",
    "operationKind": "mutation",
    "text": "mutation updateMallMutation(\n  $input: UpdateMallInput!\n) {\n  updateMall(input: $input) {\n    mall {\n      id\n      ...MallEdit_mall\n      ...MallShow_mall\n    }\n    errors {\n      key\n      messages\n    }\n  }\n}\n\nfragment MallEdit_mall on Mall {\n  name\n  phoneNumber\n  email\n  pdfMapUrl\n  address\n  smallMapUrl\n  largeMapUrl\n  mondayOpening\n  mondayClosing\n  tuesdayOpening\n  tuesdayClosing\n  wednesdayOpening\n  wednesdayClosing\n  thursdayOpening\n  thursdayClosing\n  fridayOpening\n  fridayClosing\n  saturdayOpening\n  saturdayClosing\n  sundayOpening\n  sundayClosing\n}\n\nfragment MallShow_mall on Mall {\n  name\n  phoneNumber\n  email\n  pdfMapUrl\n  address\n  shareableHomeUrl\n  shareableFlashSaleOffersUrl\n  smallMapUrl\n  largeMapUrl\n  homeUrl\n  flashSaleOffersUrl\n  mondayOpening\n  mondayClosing\n  tuesdayOpening\n  tuesdayClosing\n  wednesdayOpening\n  wednesdayClosing\n  thursdayOpening\n  thursdayClosing\n  fridayOpening\n  fridayClosing\n  saturdayOpening\n  saturdayClosing\n  sundayOpening\n  sundayClosing\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fa640f35e61bcd4923ecc2e21f1e4ecc';

module.exports = node;
